var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressPhotoQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.396 10.4624C19.7133 10.4624 20.9765 10.9857 21.9079 11.9171C22.8393 12.8485 23.3626 14.1118 23.3626 15.429C23.3626 16.7462 22.8393 18.0095 21.9079 18.9409C20.9765 19.8723 19.7133 20.3955 18.396 20.3955C17.0788 20.3955 15.8156 19.8723 14.8841 18.9409C13.9527 18.0095 13.4295 16.7462 13.4295 15.429C13.4295 14.1118 13.9527 12.8485 14.8841 11.9171C15.8156 10.9857 17.0788 10.4624 18.396 10.4624ZM18.396 22.8788C23.8841 22.8788 28.3292 25.1014 28.3292 27.8454V30.3287H8.46289V27.8454C8.46289 25.1014 12.908 22.8788 18.396 22.8788Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5504 30.0804V33.0603H29.5705V30.0804H27.3355L31.0604 26.3554L34.7854 30.0804H32.5504ZM36.5361 27.8678C36.0295 25.305 33.7722 23.3755 31.0604 23.3755C28.9074 23.3755 27.0375 24.5973 26.1063 26.3778C23.8639 26.6236 22.1206 28.5159 22.1206 30.8253C22.1206 32.0108 22.5915 33.1478 23.4298 33.9861C24.2681 34.8243 25.405 35.2953 26.5905 35.2953H36.2753C36.7645 35.2953 37.2489 35.1989 37.7008 35.0117C38.1527 34.8245 38.5634 34.5501 38.9093 34.2043C39.2552 33.8584 39.5295 33.4477 39.7167 32.9958C39.9039 32.5439 40.0003 32.0595 40.0003 31.5703C40.0003 29.6036 38.473 28.0093 36.5361 27.8678Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressPhotoQuestion);
export default __webpack_public_path__ + "static/media/ProgressPhotoQuestion.056ac019f9ddaf9868f8307fd748d00e.svg";
export { ForwardRef as ReactComponent };